import * as React from "react";
import { ITriggerManualJob } from "../../../redux/types/ITriggerManualJob";
import { IAutomaticAgreementGHWMState } from "../../types/IAutomaticAgreementGHWMState";
import { Dropdown, IDropdownOption } from "@fluentui/react/lib/Dropdown";
import TextDataInput from "../../../repertoire/components/textDataInput/TextDataInput";
import { AAG_JOB_TYPE, HIGH_WATER_MARK_KEY, HIGH_WATER_MARK_TITLE } from "../../Consts";
import { ILookupDictionary } from "../../../lookup/types/ILookupDictionary";
import { getLookupValues } from '../../../lookup/services/LookupHelpers';
import { SUBMITTER_LOOKUP } from "../../../lookup/Consts";

export interface IAagHwmProps {
    setManualJobParameters: (parameters: ITriggerManualJob) => void;
    automaticAgreementGHWM: IAutomaticAgreementGHWMState[];
    lookups: ILookupDictionary;
}

interface IAagHwmState {
    hwm: Date;
    selectedOpenSubmitters: any[];
    submitters: any[];
}

export class AutomaticAgreementGHWM extends React.Component<IAagHwmProps,
    IAagHwmState> {
    constructor(props: IAagHwmProps) {
        super(props);
        this.state = {
            hwm: null,
            selectedOpenSubmitters: [],
            submitters: getLookupValues(SUBMITTER_LOOKUP, this.props.lookups),
        };
    }

    renderIPIOptions = () => {
        const { submitters } = this.state;
        const seen = {};
        const options = (submitters || []).map((s) => {
            const ipNameNumber = s.extraFields.IPNameNumber;
            seen[ipNameNumber] = (seen[ipNameNumber] || 0) + 1;

            return {
                data: s.extraFields.IPNameNumber,
                text: `${s.description} - ${s.extraFields.IPNameNumber}`,
                key: `${s.extraFields.IPNameNumber}-${seen[ipNameNumber]}`
            };

        });

        options.sort((a, b) => {
            const descA = a.text.split(" - ")[0] || "";
            const descB = b.text.split(" - ")[0] || "";
            const textCompare = descA.localeCompare(descB);
            if (textCompare !== 0) return textCompare;

            return Number(a.data) - Number(b.data);
        });

        options.unshift({ key: "All", text: "All", data: "*" });
        return options;
    }

    changeHWM = (
        event: React.FormEvent<HTMLDivElement>,
        option?: IDropdownOption
    ) => {
        if (!option) return;

        const { setManualJobParameters } = this.props;
        const { submitters, selectedOpenSubmitters } = this.state;

        const submitterOptions = this.renderIPIOptions();
        let selectSubmitterState = [...selectedOpenSubmitters];

        if (option.key === "All") {
            if (option.selected && selectSubmitterState.length != submitterOptions.length - 1) {
                selectSubmitterState = submitterOptions
                    .map(o => o.key.toString());
            } else {
                selectSubmitterState = [];
            }
        } else if (option.selected) {
            if (!selectSubmitterState.includes(option.key.toString())) {
                selectSubmitterState.push(option.key.toString());
            }
        } else {
            if(option.key != "All"){
                selectSubmitterState = selectSubmitterState.filter(
                    key => key != "All" && key !== option.key.toString()
                );
            } else {
                selectSubmitterState = selectSubmitterState.filter(
                    key => key !== option.key.toString()
                );
            }
        }

        const selectedOptions = submitterOptions.filter(
            o => o.key !== "All" && selectSubmitterState.includes(o.key.toString())
        );

        const selectedIPIs = [...new Set(selectedOptions.map(o => o.data.toString()))];

        const manualJobParameters: ITriggerManualJob = {
            jobType: AAG_JOB_TYPE,
            jobParameters: JSON.stringify({
                "IPINameNumbers": selectedIPIs
            })
        };
        setManualJobParameters(manualJobParameters);

        let hwm = null;
        if (selectedOptions.length === 1) {
            const selectedIPI = selectedOptions[0].data.toString();
            const AAGHWM = submitters.find(
                x => x.extraFields.IPNameNumber.toString() === selectedIPI
            );
            hwm = AAGHWM ? AAGHWM.extraFields.AAGHighWaterMark : null;
        }

        this.setState({
            selectedOpenSubmitters: selectSubmitterState,
            hwm
        });
    };

    render() {
        const { hwm } = this.state;

        const onRenderPeriodDropdownTitle = (options: IDropdownOption[] | undefined): JSX.Element => {
            const displayValue = options
                .filter(o => o.text !== 'All')
                .map(o => o.text)
                .join(", ");
            return (
                <div>
                    <span>{displayValue}</span>
                </div>
            );
        };
        return (
            <>
                <div className="form-group col-md-6 col-sm-6 col-xs-12">
                    <label>Submitter</label>
                    <Dropdown
                        selectedKeys={this.state.selectedOpenSubmitters}
                        options={this.renderIPIOptions()}
                        multiSelect={true}
                        onChange={this.changeHWM}
                        placeholder={""}
                        disabled={false}
                        required={true}
                        onRenderTitle={onRenderPeriodDropdownTitle} />
                </div>
                < div className="form-group col-md-6 col-sm-6 col-xs-12" >
                    <TextDataInput
                        label={HIGH_WATER_MARK_TITLE}
                        fieldName={HIGH_WATER_MARK_KEY}
                        changeData={null}
                        value={hwm}
                        readOnly={true}
                        isHidden={false} />
                </div>
            </>
        );
    }
}
